
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateConnectorCredentialsDtoFormGroup() {
return new FormGroup({
    values: new FormControl<any | undefined>(undefined, [Validators.required]),
})
;
}
      